module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "title3"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("One")])]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle"
  }, [_vm._v("THE BEGINNING")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("At the beginning of the 20th century, America was changing—in culture, in industry, and, most of all, in size. Hoards of immigrants hailing from across the vast continent of Europe filled the streets of metropolitan cities and quickly made their presence felt in their new communities. The city of Detroit was one of the best examples of this phenomenon. By the end of the new century’s first decade, Detroit was a melting pot of ethnicity and foreign culture, spawning several neighborhoods specific to Italian, Jewish, Polish, and Irish decent. With these new communities came old world–style traditions, brought by the influx of Europeans with them to their new country. These traditions ranged from the benign to the tremendously lethal, the most dangerous of which was the underground criminal society, known by many as “the Camorra” or “the Black Hand.” Just like the many people from Italy and its tiny neighbor Sicily, who arrived in America, so did their tradition of a secret society of criminals, whose power equaled and in some cases even exceeded that of the elected government and would in later years become known as “the Mafia.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The first incarnation of this eerily mysterious fraternity in the city of Detroit, the forefather to what is today modern organized crime, was the Adamo Gang, which sprang up in 1905 and was lead by Tony and Vito Adamo. By 1910, all of the area’s liquor distribution, gambling, loan sharking, prostitution, and extortion rings were under their control. In 1913, the Adamo Gang went to war with the Gianolla Gang, a faction of street toughs led by the Gianolla brothers. The Adamos were killed by Gianolla gunmen as the pair walked together on a city street corner, paving the way for the Gianolla’s to assume control of the local underworld for themselves. In 1919, after six years of power, the Gianolla brothers were unseated by a former ally named John Vitale, who turned against his bosses and had them murdered. Vitale’s rule was short-lived and he was killed by Gianolla loyalists within a year after taking power. With the onset of Prohibition, former Gianolla lieutenant Salvatore “Singing Sam” Catalanotte was elected gangland overlord of Detroit and maintained final authority over all activities regarding the city’s newest criminal regimes, the Purple Gang, the River Gang, the East Side Gang, and the West Side Gang.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0002.jpg",
      "src": "images/e9781439633106_i0002.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This is a Detroit Police Department (DPD) mug shot of early-20th-century Mob boss Sam Gianolla, who alongside his brother Tony wrestled control of the local underworld from previous city crime lords the Adamo Gang in 1913 and ruled the Motor City streets unchallenged for the next six years. Gianolla was gunned down and killed in October 1919 on the corner of Russell Street and Monroe Avenue by hit men sent by rival gang leader Giovanni “John” Vitale. (Walter Reuther Library—Wayne State University.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0003.jpg",
      "src": "images/e9781439633106_i0003.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This is a DPD mug shot of John Gianolla, first cousin to former city overlords the Gianolla brothers, who along with his brother Vito founded the notorious Green Ones Gang in St. Louis before coming to the Motor City in 1927 and going to work for the local Italian crime syndicate. (Walter Reuther Library—Wayne State University.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "42%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0004.jpg",
      "src": "images/e9781439633106_i0004.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("DPD sergeant Emmanuel Rogers is pictured in this photograph taken in the early part of the 20th century. In 1917, Rogers, who was a leading member of the department’s special squad in charge of taking down the city’s street gangs, was murdered on the orders of the Gianolla brothers. (Paul R. Kavieff collection.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0005.jpg",
      "src": "images/e9781439633106_i0005.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This mug shot is of James (Jim) Vitale, younger brother of early-20th-century crime lord John Vitale, who along with his powerful older sibling played a major role in the city’s first two gang wars. When John was killed by members of his own gang in the fall of 1920, Jim continued on in the local underworld as an enforcer under Prohibition-era Mob leader Salvatore “Singing Sam” Catalanotte. (Walter Reuther Library—Wayne State University.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0006.jpg",
      "src": "images/e9781439633106_i0006.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Motor City Mob muscle Joe Locano is pictured in this DPD mug shot taken after an arrest in 1931. Locano, alongside underworld battery mate Joe Amico, was tried and acquitted for the gangland assassination of Gaspare “the Peacemaker” Milazzo and Sam “Sasha” Parina as the pair waited at the Vernor Highway Fish Market for what they thought was to be a peace conference between themselves and rival gang leader Chester “Big Chet” La Mare. (Walter Reuther Library—Wayne State University.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "42%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0007.jpg",
      "src": "images/e9781439633106_i0007.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Detroit Mob hit man Joe Amico is shown in 1930 while in court on trial for the infamous “Vernor Highway Fish Market Murders,” a gruesome double-homicide orchestrated by city crime boss Big Chet La Mare. Soon thereafter, Amico turned trader and aided rival gang powers in carrying out the murder of La Mare. A victim of a Mob-related death himself, Amico disappeared in 1937, killed by the area crime syndicate over a monetary dispute. (Walter Reuther Library—Wayne State University.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "34%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0008.jpg",
      "src": "images/e9781439633106_i0008.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Hamtramck-area Mob kingpin Big Chet La Mare, alongside his wife, is seen in a family photograph from the late 1920s. La Mare, who was the leader of the city’s infamous West Side Gang, became Detroit’s number one crime boss in 1930 when he orchestrated the Vernor Highway Fish Market Murders. However, Big Chet’s rule over the Motor City was short-lived, and he was murdered by his own men in January 1931. (Walter Reuther Library—Wayne State University.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0009.jpg",
      "src": "images/e9781439633106_i0009.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Slain Detroit radio broadcaster Gerald Buckley is shown in a picture taken in the years before his death at the hands of the Motor City underworld. Buckley was killed on July 23, 1930, while sitting in the lobby of the La Salle Hotel following one of his many on-air rants against the local crime syndicate. Upset with his attention-grabbing antics, the area Italian Mob ordered him to be killed. (Walter Reuther Library—Wayne State University.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "90%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0010.jpg",
      "src": "images/e9781439633106_i0010.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This late-Prohibition-era lineup photograph is of members of both the Purple Gang, the city’s premiere Jewish bootlegging cartel, and the River Gang, the area’s top Italian booze-smuggling crew. Also pictured, intermingled among the notorious dual vice-factions, are several members of the local Polish crime syndicate. Pay special attention to: Joseph “Joe Scarface” Bommarito (No. 1), the River Gang’s primary enforcer; Eddie Fletcher (No. 13) and Abe Axler (No. 16), who were two of the Purple Gang’s best assassins, and who would both be murdered by their counterparts in the Jewish Mob; James “Blackie” Licavoli (No. 11), River Gang member and future Mafia boss in Cleveland; James Moceri (No. 12), Licavoli’s first cousin and fellow River Ganger; and Chester Tutha (No. 9), one of Detroit’s biggest independent crime lords of the time period, leading Hamtramck’s Lizard Gang. (Walter Reuther Library—Wayne State University.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0011.jpg",
      "src": "images/e9781439633106_i0011.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Purple Gang boss Abe Bernstein is pictured in a DPD mug shot from the early 1920s. Bernstein, along with his three brothers, built their Detroit-area Jewish crime syndicate into one of the most powerful, respected, and feared vice gangs in the annals of American history. Despite ruling less than a decade, the gang’s legacy is long-standing as an iconic symbol of the local underworld. (Paul R. Kavieff collection.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0012.jpg",
      "src": "images/e9781439633106_i0012.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This early mug shot is of Detroit gang leader and future Motor City godfather Joseph “Joe Uno” Zerilli. Through the years, Zerilli would build a reputation second to none in the nation’s underworld. During Prohibition he was a top member of the infamous East Side Gang. (Paul R. Kavieff collection.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0013.jpg",
      "src": "images/e9781439633106_i0013.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("River Gang boss and future Detroit Mob chieftain Peter Licavoli is shown in a DPD mug shot taken in the mid-1930s. After Prohibition ended, Licavoli, originally from St. Louis and whose two brother-in-laws Joe Scarface Bommarito and Frank Cammerata were fellow gangland figures, was named a captain by Mafia boss Bill Tocco. (Paul R. Kavieff collection.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0014.jpg",
      "src": "images/e9781439633106_i0014.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Motor City Mob lieutenant Joe Scarface Bommarito is pictured sitting in court during his trial for the Gerald Buckley murder in the fall of 1930. A top member of the River Gang, Bommarito and his two codefendants were acquitted of all charges, and he went on to become a powerful Mafia captain in the newly formed Detroit crime family. Bommarito died of natural causes in 1965. (Walter Reuther—Wayne State University.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0015.jpg",
      "src": "images/e9781439633106_i0015.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("East Side Gang leader Leonardo “Black Leo” Cellura is pictured alongside his fingerprints in a 1930s DPD wanted poster that was displayed across the city in an attempt to apprehend the well-known fugitive. After nearly a decade on the run from the law, Cellura, who was wanted for murder and who, along with William “Black Bill” Tocco and Joseph “Joe Uno” Zerilli, founded and ran the highly feared East Side Gang, was caught and jailed and eventually died of natural causes in 1972 after his release. (Paul R. Kavieff collection.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0016.jpg",
      "src": "images/e9781439633106_i0016.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Detroit Mafia figure Joseph “Long Joe” Bommarito (second from left) is pictured alongside his first cousin Joe Scarface Bommarito (third from left) and Purple Gang associates David Feldman (next to Joe Scarface) and Dominic Licavoli (far right) in a DPD line-up photograph from the 1930s. Millman was notorious Purple enforcer Harry Millman’s younger brother, while Long Joe would go on to become a powerful street lieutenant in the Motor City crime family and Feldman would become a highly-valued crime family associate. Also pictured in the photograph are local underworld figures Frank Cammerata and James Licavoli. (Paul R. Kavieff collection.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0017.jpg",
      "src": "images/e9781439633106_i0017.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This police mug shot of Frank “Frankie C” Cammerata was taken in the early 1930s. Cammerata was a key member in the River Gang and one of the local underworld’s most dreaded gunmen of the early century. Deported in 1937, Cammerata snuck back into the country in the 1940s, serving as the Detroit Mafia’s representative in Toledo and Youngstown before dying of natural causes in 1965. (Paul R. Kavieff collection.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "44%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0018.jpg",
      "src": "images/e9781439633106_i0018.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Joseph “Joe Misery” Moceri, a coleader of the River Gang, is pictured leaving a court appearance in the late 1920s. After Prohibition, Moceri became a vital cog in the hierarchy of the city’s Mafia crime family before succumbing to a violent death in August 1968, when he was killed by masked assailants in a robbery of a warehouse he owned in west Detroit. (Walter Reuther Library—Wayne State University.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0019.jpg",
      "src": "images/e9781439633106_i0019.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Joe Moceri (second from left), alongside several members of the River Gang, is pictured in this DPD lineup photograph from the late 1920s. Pay special attention to Calogero “Leo Lips” Moceri (third from left), Joe’s younger brother, who would go on to become the underboss of the Cleveland Mafia in the 1970s and whose violent murder in 1976 would set off a bloody Mob war in Ohio that lasted close to two years. (Paul R. Kavieff collection.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0020.jpg",
      "src": "images/e9781439633106_i0020.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Former River Gang lieutenant and Detroit Mafia captain Joseph “Joe the Bum” Massei is pictured in a DPD mug shot from the early-Prohibition era. Getting his start under city crime lords the Gianolla brothers and then working as a trusted aid to Pete Licavoli, Massei was eventually appointed the syndicate’s boss in charge of overseeing the family’s interests in Florida. Massei died in 1972. (Paul R. Kavieff collection.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0021.jpg",
      "src": "images/e9781439633106_i0021.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This Prohibition-era photograph is of bootlegging activities taking place on the shores of the Detroit River, taken by the DPD and used as a diagram to demonstrate how alcoholic contraband was smuggled up the body of water from Canada on to U.S. territory and into a series of local underground speakeasies and Mob-run booze joints for illegal consumption. (Walter Reuther Library—Wayne State University.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0022.jpg",
      "src": "images/e9781439633106_i0022.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Stranded booze runners are on Lake St. Clair in the frigid winter of 1929. During Prohibition, the area’s bootlegging gangs would transport large truckloads of black-market alcohol from Canada to the United States across the frozen lake water in the winter. Sometimes, as shown here, the weight of the delivery truck would break through the ice, leaving the smugglers and their shipments stuck in the lake. (Walter Reuther Library—Wayne State University.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0023.jpg",
      "src": "images/e9781439633106_i0023.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("East Side Gang leaders and future Motor City Mob dons Joseph “Joe Uno” Zerilli (second from right) and William “Black Bill” Tocco (second from left) stand with detective William Delisle and prosecutor Frank Schemanski while being arraigned in the early 1930s. Zerilli and Tocco were brother-in-laws and best friends, aiding and counseling each other through their storied careers in the Detroit underworld. (Walter Reuther Library—Wayne State University.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "45%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0024.jpg",
      "src": "images/e9781439633106_i0024.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("River Gang member and future local Mob lieutenant Thomas “Yonnie” Licavoli (left), younger brother of bootlegging czar Pete Licavoli, is pictured leaving court with his attorney. After Prohibition, Yonnie and his brother-in-law Frank Cammerata were dispensed by the Motor City Mafia to Toledo in order to look after the syndicate’s interests in Ohio. Soon thereafter, Yonnie was imprisoned on murder charges. (Paul R. Kavieff collection.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0025.jpg",
      "src": "images/e9781439633106_i0025.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Located in the basement of this laundry on 10 Mile and Dequindre Roads on the city’s east side was one of Detroit’s numerous speakeasies, referred to locally as “blind pigs,” these after-hours locales were top-secret underground booze joints run by the area crime syndicate offering spirits and good times to a thirsty public during the 1920s and early 1930s. (Walter Reuther Library—Wayne State University.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633106_i0026.jpg",
      "src": "images/e9781439633106_i0026.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Here is a look inside one of the city’s most popular blind pig, located at the corner of Randolph and Columbia, during a busy night in the late 1920s. This particular establishment, owned and operated by the Purple Gang, was one of the most popular of the era. (Walter Reuther Library—Wayne State University.)")])])])])])]), _c('a', {
    attrs: {
      "id": "title3"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cd62e16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439633106_c01.vue
// module id = 78
// module chunks = 0